import UltraEditor from "./Editor";

export default UltraEditor;
